module.exports = __webpack_public_path__ + "img/about大图3.01f47adb.jpg";